"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.getRequestHeaders = exports.getResponse = exports.parseBodyAsJson = void 0;
// biome-ignore lint/style/useNodejsImportProtocol: needs to be polyfill by client apps
const events_1 = require("events");
const _1 = __importDefault(require("."));
const EMPTY_RESPONSE = Object.freeze({});
const errorEmitter = new events_1.EventEmitter();
const parseBodyAsJson = (body) => {
    try {
        if (body.length && !body.startsWith('<')) {
            return JSON.parse(body);
        }
    }
    catch (error) {
        console.error(error);
    }
    return EMPTY_RESPONSE;
};
exports.parseBodyAsJson = parseBodyAsJson;
const getResponse = async (response, withStatusCode = false, rawResponse = false) => {
    if (rawResponse && response.ok) {
        if (withStatusCode) {
            return { httpStatus: response.status, ...response };
        }
        return response;
    }
    // Parsing the response as text prevents JSON parsing empty response error
    const txt = await response.text();
    const data = (0, exports.parseBodyAsJson)(txt);
    if (response.ok) {
        if (withStatusCode) {
            return { httpStatus: response.status, ...data };
        }
        return data;
    }
    errorEmitter.emit('request:error', response.status, { ...data });
    return Promise.reject({ status: response.status, ...data });
};
exports.getResponse = getResponse;
const getRequestHeaders = (headers, contentType = 'application/json') => {
    const requestHeaders = JSON.parse(JSON.stringify({
        ...headers,
        ...(contentType && { 'Content-Type': contentType }),
    }));
    if ('authorization' in requestHeaders) {
        if (!requestHeaders.authorization) {
            requestHeaders.authorization = undefined;
        }
    }
    else if (_1.default.token) {
        requestHeaders.authorization = `Bearer ${_1.default.token}`;
    }
    return requestHeaders;
};
exports.getRequestHeaders = getRequestHeaders;
const request = (method, endpoint, data, 
// biome-ignore lint/style/useDefaultParameterLast: not changing this
headers = {}, apiEndpoint) => {
    let url = `${apiEndpoint}/${endpoint}`;
    const requestHeaders = (0, exports.getRequestHeaders)(headers);
    if (method === 'GET') {
        const queryString = data ? new URLSearchParams(data).toString() : undefined;
        if (queryString) {
            url += `?${queryString}`;
        }
        return fetch(url, {
            method,
            headers: requestHeaders,
        }).then(exports.getResponse);
    }
    const requestPromise = fetch(url, {
        method,
        body: JSON.stringify(data),
        headers: requestHeaders,
    });
    return requestPromise.then(exports.getResponse);
};
exports.request = request;
//# sourceMappingURL=request.js.map